import React, { useState, useEffect } from "react";
import ChannelArea from "./../../components/channelarea.js";
import Suggestions from "./suggestions.js";
import VideoContainer from "./videocontainer.js";
import Hearts from "./Hearts.js";
import LayoutTop from "../../components/layouttop.js";
import axios from "axios";
import { Link } from "react-router-dom";
import { useParams } from "react-router";
import Loading from '../../components/Loading.js';
import ErrorState from '../../components/ErrorState.js';
import { Adsense } from "@ctrl/react-adsense";
import { API_BASE } from "../../config";

import "../styles.css";

const Post = () => {
  const { post_id } = useParams();
  const { video_seq } = useParams();
  const [search, setSearch] = useState(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    var url = "";
    if (post_id) {
      url = `${API_BASE}/post/${post_id}/page`;
    } else if (video_seq) {
      url = `${API_BASE}/video/${video_seq}/page`;
    }

    let cancelled = false;
    setError(false);
    setSearch(null);

    axios
      .get(url)
      .then(function (response) {
        if (cancelled) return;
        setSearch(response.data);
        document.title = "브이라이브 아카이브 - " + response.data.post.title;
      })
      .catch(function (error) {
        if (cancelled) return;
        setError(true);
      });

    return () => {
      cancelled = true;
    };
  }, [post_id, video_seq, attempt]);

  if (error)
    return (
      <ErrorState
        message="영상을 불러오지 못했습니다."
        onRetry={() => setAttempt((a) => a + 1)}
      />
    );
  if (search === null) return <Loading />; // 로딩 애니메이션 사용
  if (search === "not found") return <>찾을 수 없음</>;
  const post = search.post;
  const channel = search.channel;
  const suggestions = search.suggestions;

  const channelUrl = channel.channelAlias
    ? channel.channelAlias
    : channel.channelCode;

  return (
    <>
      <div className="layout--2CJge">
        <LayoutTop />
        <div className="layout_main--2iozc">
          <div className="snb--dI3H2">
            <nav className="nav--Lwe6x">
              <div className="channel_area--3-r0f">
                <ChannelArea channel={channel} />
              </div>
              <ul className="board_group_list--3BSLj">
                <li className="board_group_item--uTaOQ">
                  <strong className="group_name--2Ufyg">Official</strong>
                  <ul className="board_list--iksmp">
                    <li className="board_item--8Emtz is_active--3yXYJ">
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        className="board_icon--3B72f"
                      >
                        <path
                          fill="#B5B5BD"
                          d="M12 0c3.314 0 6 2.686 6 6v6c0 3.314-2.686 6-6 6H6c-3.314 0-6-2.686-6-6V6c0-3.314 2.686-6 6-6h6zm-.66 10.303l-1.887 1.373.648.436 1.165.78c.11.075.248.096.376.06.24-.068.38-.319.31-.559l-.376-1.325-.236-.765zm-2.19-5.73c-.235-.082-.493.042-.576.277l-.872 2.48H4.897c-.138 0-.269.063-.354.171-.156.196-.123.48.073.636l2.156 1.711-.706 2.482c-.037.132-.012.275.068.387.146.203.429.25.632.104l6.496-4.671c.118-.085.188-.222.188-.367 0-.25-.202-.453-.452-.453h-2.699l-.871-2.48c-.046-.129-.148-.23-.277-.276z"
                        ></path>
                      </svg>
                      <Link
                        className="board_link--10CG-"
                        to={"/channel/" + channelUrl}
                      >
                        {channel.channelName} 채널
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>
          </div>
          <div className="snb_dimmed--IZGKU"></div>
          <div className="layout_content--3-hGQ">
            <div className="lnb--3RTnS -right_menu_text--23eET">
              <div className="lnb_inner--1EWFM">
                <h2 className="lnb_pc_title--1lAio">
                  {channel.channelName} Board
                </h2>
              </div>
            </div>
            <VideoContainer post={post} channel={channel} />
          </div>
          <div className="layout_right--2_POD">
            <Suggestions suggestions={suggestions} />
          </div>

          <Hearts />
          <Adsense client="ca-pub-3850710731106550" slot="6249513304" />
        </div>
      </div>
    </>
  );
};

export default Post;
